export default "__VITE_ASSET__BO92165i__"